import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { TransactionNoteDto } from 'api/Transaction/Types/TransactionNoteDto'
import { Link } from 'components/Link'
import { hasPermission } from 'utils/permissionsValidator'

interface NoteListProps {
  transactionNotes: TransactionNoteDto[]
  permissions: PermissionDto[]
  onClick?: (e: boolean) => void
}

export const NoteList: React.FC<NoteListProps> = ({ transactionNotes, permissions, onClick }) => {
  const notes = transactionNotes || []

  const handleClick = () => {
    if (hasPermission(permissions, PermissionsEnum.CanEditPaymentNotes) && onClick) {
      onClick(true)
    }
  }

  return (
    <div id='field'>
      <ul style={{ marginBottom: 0 }}>
        {notes
          .filter((_x, index) => index <= 2)
          .map((note) => (
            <li key={note.id as string} style={{ cursor: 'pointer' }} onClick={handleClick}>
              {note.description}
            </li>
          ))}
      </ul>
      {notes.length > 3 && (
        <Link onClick={handleClick} to='#'>
          ({notes.length}) show more ...
        </Link>
      )}
    </div>
  )
}

interface NoteTextListProps {
  transactionNotes: TransactionNoteDto[]
}

export const NoteTextList: React.FC<NoteTextListProps> = ({ transactionNotes }) => {
  const notes = transactionNotes || []

  return (
    <div id='field' style={{ width: '100%' }}>
      <textarea style={{ width: '100%' }} rows={3} disabled>
        {notes.map((x) => x.description).join('\n')}
      </textarea>
    </div>
  )
}

export const filterClientNotes = (notes: TransactionNoteDto[]): TransactionNoteDto[] => {
  return (notes || []).filter((x) => !x.transaction)
}

export const filterTransactionNotes = (notes: TransactionNoteDto[]): TransactionNoteDto[] => {
  return (notes || []).filter((x) => !!x.transaction)
}
